import { transformCurrencyAmountDto } from './currency-amount';
export const transformReturnCurrencyConversionMarkupDto = returnCurrencyConversionMarkup => {
  return {
    rate: returnCurrencyConversionMarkup.rate,
    provider: returnCurrencyConversionMarkup.provider
  };
};
export const transformReturnCurrencyConversionExchangeDto = returnCurrencyConversionExchange => {
  return {
    baseRate: transformCurrencyAmountDto(returnCurrencyConversionExchange.base_rate),
    roundedRate: transformCurrencyAmountDto(returnCurrencyConversionExchange.rounded_rate)
  };
};
export const transformReturnCurrencyConversionShippingDto = returnCurrencyConversionShipping => {
  return {
    method: returnCurrencyConversionShipping.method,
    afterConversionPrice: transformCurrencyAmountDto(returnCurrencyConversionShipping.after_conversion_price),
    beforeConversionPrice: transformCurrencyAmountDto(returnCurrencyConversionShipping.before_conversion_price)
  };
};
export const transformReturnCurrencyConversionPriceDto = returnCurrencyConversionPrice => {
  return {
    afterConversionPrice: transformCurrencyAmountDto(returnCurrencyConversionPrice.after_conversion_price),
    beforeConversionPrice: transformCurrencyAmountDto(returnCurrencyConversionPrice.before_conversion_price)
  };
};
export const transformReturnCurrencyConversionDto = returnCurrencyConversion => {
  return {
    itemPrice: returnCurrencyConversion.item_price && transformReturnCurrencyConversionPriceDto(returnCurrencyConversion === null || returnCurrencyConversion === void 0 ? void 0 : returnCurrencyConversion.item_price),
    factualShipping: returnCurrencyConversion.factual_shipping && transformReturnCurrencyConversionShippingDto(returnCurrencyConversion === null || returnCurrencyConversion === void 0 ? void 0 : returnCurrencyConversion.factual_shipping),
    returnShipping: returnCurrencyConversion.return_shipping && transformReturnCurrencyConversionPriceDto(returnCurrencyConversion === null || returnCurrencyConversion === void 0 ? void 0 : returnCurrencyConversion.return_shipping),
    buyerProtectionFee: returnCurrencyConversion.buyer_protection_fee && transformCurrencyAmountDto(returnCurrencyConversion === null || returnCurrencyConversion === void 0 ? void 0 : returnCurrencyConversion.buyer_protection_fee),
    exchange: transformReturnCurrencyConversionExchangeDto(returnCurrencyConversion.exchange),
    markup: transformReturnCurrencyConversionMarkupDto(returnCurrencyConversion.markup)
  };
};